// ======================================================================
// 📁 File: src/modules/ppe/pages/orders/CreateOrderPage.js
// ======================================================================

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import ppeOrderService from "../../services/ppeOrderService";
// ✅ [2026-02-19 19:10 IST] Use backend API client instead of fetch
import axiosClient from "../../../../api/axiosClient";

// ------------------------------------------------------------------
// Local constants (ERP-safe)
// ------------------------------------------------------------------
const STATUS_MAP = {
  1: "Draft",
};

const PRIORITY_MAP = {
  LOW: 1,
  NORMAL: 3,
  HIGH: 5,
  URGENT: 7,
};

export default function CreateOrderPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    order_number: "",
    order_type: "ETO",

    // ✅ [2026-02-19 18:55 IST] Added BP linkage field
    business_partner_id: "",

    customer_name: "",
    customer_reference: "",
    project_reference: "",
    priority: "NORMAL", // UI label
    order_date: "",
    promised_delivery_date: "",
    remarks: "",
  });

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // ✅ [2026-02-19 18:55 IST] Customer lookup dropdown state
  const [customerOptions, setCustomerOptions] = useState([]);

  const onChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  // ✅ [2026-02-19 18:55 IST] CUSTOMER SEARCH (Business Partner lookup)
  // ✅ [2026-02-19 19:10 IST] FIX: use axiosClient instead of fetch
const searchCustomers = async (text) => {
  if (!text || text.length < 2) {
    setCustomerOptions([]);
    return;
  }

  try {
    const res = await axiosClient.get(
      "/api/ppe/masters/business-partner/customers/lookup",
      {
        params: { search: text },
      }
    );

    setCustomerOptions(res.data?.data?.items || []);
  } catch (e) {
    console.error("Customer lookup failed", e);
  }
};


  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // ✅ [2026-02-19 18:55 IST] Validation updated to BP id
    if (
      !form.order_number ||
      !form.business_partner_id ||
      !form.order_date
    ) {
      setError("Order Number, Customer and Order Date are mandatory");
      return;
    }

    setSaving(true);
    try {
      const payload = {
        ...form,
        status_id: 1, // Draft
        priority: PRIORITY_MAP[form.priority],
      };

      const res = await ppeOrderService.createOrder(payload);
      navigate(`/ppe/orders/${res.id}`);
    } catch (err) {
      setError(err?.message || "Failed to create order");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <div style={{ maxWidth: 1000, width: "100%" }}>
        {/* HEADER */}
<div
  style={{
    background: "linear-gradient(90deg, #5f0cff, #7b2cff)",
    borderRadius: 14,
    padding: "16px 22px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
  }}
>
  <div>
    <div style={{ fontSize: 20, fontWeight: 700 }}>
      Create Production Order
    </div>
    <div style={{ fontSize: 13, opacity: 0.9 }}>
      Status: {STATUS_MAP[1]}
    </div>
  </div>

  <button
    onClick={() => navigate("/ppe/orders")}
    style={{
      background: "#fff",
      color: "#5f0cff",
      border: "none",
      borderRadius: 8,
      padding: "8px 14px",
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    ← Back to Orders
  </button>
</div>

        {/* FORM */}
        <div className="card">
          <div className="card-body">
            <form onSubmit={onSubmit}>
              {error && (
                <div className="alert alert-danger mb-3">
                  {error}
                </div>
              )}

              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">
                    Order Number <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    value={form.order_number}
                    onChange={(e) =>
                      onChange("order_number", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Order Type</label>
                  <select
                    className="form-select"
                    value={form.order_type}
                    onChange={(e) =>
                      onChange("order_type", e.target.value)
                    }
                  >
                    <option value="ETO">Engineer-to-Order</option>
                    <option value="MTO">Make-to-Order</option>
                  </select>
                </div>

                {/* ✅ [2026-02-19 18:55 IST] Customer Searchable Dropdown */}
                <div className="col-md-8 position-relative">
                  <label className="form-label">
                    Customer <span className="text-danger">*</span>
                  </label>

                  <input
                    className="form-control"
                    placeholder="Search customer..."
                    value={form.customer_name}
                    onChange={(e) => {
                      onChange("customer_name", e.target.value);
                      searchCustomers(e.target.value);
                    }}
                  />

                  {customerOptions.length > 0 && (
                    <div
                      className="border rounded bg-white w-100"
                      style={{
                        position: "absolute",
                        zIndex: 1000,
                        maxHeight: 200,
                        overflowY: "auto",
                      }}
                    >
                      {customerOptions.map((c) => (
                        <div
                          key={c.id}
                          className="p-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setForm((prev) => ({
                              ...prev,
                              customer_name: `${c.bp_name} (${c.bp_code})`,
                              business_partner_id: c.id,
                            }));
                            setCustomerOptions([]);
                          }}
                        >
                          {c.bp_name} ({c.bp_code})
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Customer PO No</label>
                  <input
                    className="form-control"
                    value={form.customer_reference}
                    onChange={(e) =>
                      onChange("customer_reference", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Project / Job Reference
                  </label>
                  <input
                    className="form-control"
                    value={form.project_reference}
                    onChange={(e) =>
                      onChange("project_reference", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">
                    Order Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={form.order_date}
                    onChange={(e) =>
                      onChange("order_date", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">
                    Expected Delivery Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={form.promised_delivery_date}
                    onChange={(e) =>
                      onChange("promised_delivery_date", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Priority</label>
                  <select
                    className="form-select"
                    value={form.priority}
                    onChange={(e) =>
                      onChange("priority", e.target.value)
                    }
                  >
                    <option value="LOW">Low</option>
                    <option value="NORMAL">Normal</option>
                    <option value="HIGH">High</option>
                    <option value="URGENT">Urgent</option>
                  </select>
                </div>

                <div className="col-12">
                  <label className="form-label">Remarks</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={form.remarks}
                    onChange={(e) =>
                      onChange("remarks", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={saving}
                >
                  {saving ? "Saving…" : "Save Draft"}
                </button>

                <button
                  type="button"
                  className="btn btn-outline-secondary ms-2"
                  onClick={() => navigate("/ppe/orders")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
